import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Laba Rugi',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Laba Rugi',
        href: '/adm/fin/laporan/laba-rugi',
        active: true,
      },
    ],
    form: {
      periode: '',
    },
    report: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeLabaRugi(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getLabaRugi({ commit, state }) {
    commit('changeLabaRugi', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/laporan/laba-rugi`, data.form);
    commit('changeLabaRugi', {
      report: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },
};
